import { FC } from "react";
import { EditAddressFormModel, EditPersonInfoFormModel } from "./editSingleShareholderDomain";
import { observer } from "mobx-react";
import { MTextInput } from "../../components-v2/TextInput";
import { PhoneInput } from "../../components-v2/PhoneInput";
import { MDateInput } from "../../components-v2/DateInput";
import { MSelect } from "../../components-v2/Select";

import { useTranslation } from "../../stores/RootStoreContext";
import { BooleanFieldModel, StringFieldModel } from "../../common/commonForms";
import { EditAddressForm } from "./EditAddressForm";
import { YesNoQuestion } from "../../dbot/common/commonComponents";
import { LoadingIndicator } from "../../components-v2/LoadingIndicator";

export const EditPersonInfoForm: FC<{
  model: EditPersonInfoFormModel;
  utlNumber?: StringFieldModel;
  shareholderAddress?: EditAddressFormModel;
  issuedShareholderCertificate?: BooleanFieldModel;
  isShareholderView?: boolean;
  showField: (field: string) => boolean;
  isSwedishOrgNo: boolean;
  fetchShareholders?: () => void;
  isLoadingShareholders?: boolean;
}> = observer(
  ({
    model,
    utlNumber,
    shareholderAddress,
    issuedShareholderCertificate,
    isShareholderView = false,
    showField,
    isSwedishOrgNo,
    fetchShareholders,
    isLoadingShareholders,
  }) => {
    const { t } = useTranslation();
    return (
      <>
        {!isShareholderView && (
          <>
            {showField("socialSecurityNumber") && (
              <MTextInput
                label={t("shareholders.editSingle.socialSecurityNumber")}
                model={model.socialSecurityNumber}
                onBlur={() => {
                  fetchShareholders?.();
                  model.socialSecurityNumber.commit();
                }}
              />
            )}
            {isLoadingShareholders === true && (
              <LoadingIndicator size="sm" label={t("shareholders.editSingle.finding-duplicates")} />
            )}
            {showField("firstName") && (
              <MTextInput label={t("shareholders.editSingle.firstName")} model={model.firstName} />
            )}
            {showField("middleName") && (
              <MTextInput
                label={t("shareholders.editSingle.middleName")}
                model={model.middleName}
              />
            )}
            {showField("lastName") && (
              <MTextInput label={t("shareholders.editSingle.lastName")} model={model.lastName} />
            )}
          </>
        )}
        {showField("birthDate") && (
          <MDateInput label={t("shareholders.editSingle.birthDate")} model={model.birthDate} />
        )}
        {utlNumber && !isShareholderView && showField("utlNumber") && (
          <MTextInput label={t("shareholders.editSingle.utlNumber")} model={utlNumber} />
        )}
        {showField("email") && (
          <MTextInput label={t("shareholders.editSingle.email")} model={model.email} />
        )}
        {showField("phoneNumber") && <PhoneInput model={model.phoneNumber} />}
        {shareholderAddress && <EditAddressForm model={shareholderAddress} showField={showField} />}
        {issuedShareholderCertificate && isSwedishOrgNo && !isShareholderView && (
          <YesNoQuestion
            question={t("newShareholder.issuedShareholderCertificate")}
            field={issuedShareholderCertificate}
          />
        )}
        {showField("gender") && (
          <MSelect label={t("shareholders.editSingle.gender")} model={model.gender} />
        )}
      </>
    );
  },
);
